export default function SolutionFinder(finderData) {
  return {
    data: finderData,
    industry: '',
    application: '',
    productType: '',

    get selectedIndustry() {
      if (!this.industry) return null;
      return this.data.find((i) => i.id == this.industry) || null;
    },

    get availableApplications() {
      return this.selectedIndustry ? this.selectedIndustry.a : [];
    },

    get selectedApplication() {
      if (!this.application) return null;
      return this.availableApplications.find((a) => a.id == this.application) || null;
    },

    get availableProductTypes() {
      return this.selectedApplication ? this.selectedApplication.pt : [];
    },

    get showApplicationSelect() {
      return this.industry && this.availableApplications.length > 0;
    },

    get showProductTypeSelect() {
      return this.application && this.availableProductTypes.length > 1;
    },

    get isEmpty() {
      return this.application && this.availableProductTypes.length === 0;
    },

    get destinationUrl() {
      if (this.isEmpty) return '/about-us/contact-us';
      if (this.productType) return this.productType;
      if (this.application && this.availableProductTypes.length === 1) {
        return this.selectedApplication.u;
      }
      if (this.application) return this.selectedApplication.u;
      if (this.selectedIndustry) return this.selectedIndustry.u;
      return '';
    },

    get buttonLabel() {
      return this.isEmpty ? 'Request a Consultation' : 'View Solutions';
    },

    get isActive() {
      return this.industry !== '';
    },

    resetFrom(level) {
      if (level <= 1) { this.application = ''; }
      if (level <= 2) { this.productType = ''; }
    },
  };
}
